import {HTTP} from '../../../services/api-service.js';
import commonObj from '../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;

const ConvertBatchSOtoInvoiceStore = {
    namespaced: true,
    state:{
        searchModel:{
            compCode:"",
            DateFrom:"",
            DateTo:"",         
            EntNum:"",           
            TxNumFrom:"",
            TxNumTo:""      
        }
    },
    actions:{     
        getOutStandingSOList({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/so/getOutStandingSOList', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },  
        convertSOToInvoice({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/so/convertSOToInvoice', { soNums: param.soNums }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
    }
};
export default ConvertBatchSOtoInvoiceStore;